import {NgModule} from "@angular/core";
import {AboutComponent} from "./about/about.component";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {HttpClientModule} from "@angular/common/http";
import {APPRoutingModule} from "../../app.routes";
import {ExcelModule, GridModule} from "@progress/kendo-angular-grid";
import {ButtonsModule} from "@progress/kendo-angular-buttons";
import {DropDownListModule, DropDownsModule} from "@progress/kendo-angular-dropdowns";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {DialogModule} from "@progress/kendo-angular-dialog";
import {InputsModule} from "@progress/kendo-angular-inputs";
import {DateInputsModule} from "@progress/kendo-angular-dateinputs";
import {IntlModule} from "@progress/kendo-angular-intl";
import {NgxLoadingModule} from "ngx-loading";
import {PopupModule} from "@progress/kendo-angular-popup";
import {CommonModule} from "@angular/common";
import {ChangePasswordComponent} from "./change-password/change-password.component";

@NgModule({
  declarations: [AboutComponent, ChangePasswordComponent],
  exports: [AboutComponent, ChangePasswordComponent],
  imports:[GridModule, CommonModule,
    ExcelModule, ButtonsModule, DropDownsModule, DropDownListModule, FormsModule, ReactiveFormsModule,
    DialogModule, InputsModule, DateInputsModule, IntlModule, PopupModule]
})

export class CommonComponentsModule {}
